import TemplateWeek, {
  ITemplateWeek,
  TTemplateWeek,
} from 'modules/shift_management/store/internal/models/TemplateWeek'

class TemplateWeeks {
  templateWeeks: TemplateWeek[]

  constructor(templateWeeks: TemplateWeek[]) {
    this.templateWeeks = templateWeeks
  }

  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(templateWeeks: ITemplateWeek[]): TemplateWeeks {
    const templateWeekObjects = templateWeeks.map((templateWeek) => {
      return TemplateWeek.buildFromProps(templateWeek)
    })

    return new TemplateWeeks(templateWeekObjects)
  }

  static buildFromGraphQL(templateWeeks: TTemplateWeek[]): TemplateWeeks {
    const templateWeekObjects = templateWeeks.map((templateWeek) => {
      return TemplateWeek.buildFromGraphQL(templateWeek)
    })

    return new TemplateWeeks(templateWeekObjects)
  }
}

export default TemplateWeeks
